import { render } from "./HumanSkillChart.vue?vue&type=template&id=36bf6b96&scoped=true"
import script from "./HumanSkillChart.vue?vue&type=script&lang=ts"
export * from "./HumanSkillChart.vue?vue&type=script&lang=ts"

import "./HumanSkillChart.vue?vue&type=style&index=0&id=36bf6b96&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-36bf6b96"

export default script